import { func } from "prop-types";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { ReactComponent as Warning } from 'assets/images/svg/warning.svg';
import { ReactComponent as Download } from 'assets/images/svg/download.svg';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { checkDriverId, deleteDriverAccount, getBusinessList, getDriverList, patchBusinessList, saveDriverAccount, saveDriverExcel, setNewBusinessList, updateDriverList } from "crud/auth.crud";

import _ from "lodash";
import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import Pagination from "pages/Custom/Pagination";

// import images
import weaver from "../../assets/images/weaver.png";
import loading from "../../assets/images/loading.gif";

const DriverManagementScreen = () => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()

  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [reset, setReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [memberId, setMemberId] = useState('');
  const [memberIdConfirm, setMemberIdConfirm] = useState(false);
  const [memberPassword, setMemberPassword] = useState('');
  const [memberPasswordConfirm, setMemberPasswordConfirm] = useState('');
  const [memberName, setMemberName] = useState('');
  const [memberEmail, setMemberEmail] = useState('');
  const [memberCellphone, setMemberCellphone] = useState('');
  const [userType, setUserType] = useState('driver');
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.id);
  const [myId, setMyId] = useState(selector.auth?.user?.id);
  const [driverListFile, setDriverListFile] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState('');
  const [onUpload, setOnUpload] = useState(false);
  const [pagesGroup, setPagesGroup] = useState(1)
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4])
  const [contentCount, setContentCount] = useState()

  const getDataList = async () => {
    setOnUpload(true)

    let params = {
      page: page,
      company: companyId
    }

    const response = await getDriverList(params);
    const content = response.data?.results || [];
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount || contentCount !== dataCount) {
      if(dataCount === 0){
        setContentCount(1)
      }else{
        setContentCount(dataCount)
      }
      let newArr = []
      for (let i = pagesGroup - 1; i < pagesGroup + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      if(newArr.length === 0) newArr = [1]
      setPageArr(newArr)
    }
    if (content.length > 0) {
      setDataList([...content])
    } else {
      setDataList(false)
    }
    setOnUpload(false)
  }

  const checkUserId = async () => {
    var reg = /^[A-Za-z\d]{3,15}$/
    if(memberId.length === 0){
      return('아이디를 입력해주세요.')
    }else if(!reg.test(memberId)){
      return alert('3-15자의 영문/숫자 조합으로 아이디를 입력해주세요.')
    }
    setOnUpload(true)
    const params = {
      user_id: memberId,
    }
    const rs = await checkDriverId(params)
    if (rs.data?.result === 'success') {
      setMemberIdConfirm(true)
    }
    alert(rs.data?.msg)
    setOnUpload(false)
  }

  const isValiddate = () => {
    let regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (memberId === '') {
      return alert("아이디를 입력해주세요.")
    }
    if (!memberIdConfirm) {
      return alert("아이디 중복확인을 해주세요.")
    }
    if (!regex.test(memberPassword) || memberPassword === '') {
      return alert("8자 이상의 영문/숫자 조합으로 비밀번호를 입력해주세요.")
    }
    if (memberPasswordConfirm === '' || memberPassword !== memberPasswordConfirm) {
      return alert("비밀번호확인을 정확히 입력해주세요.")
    }
    if (memberName === '') {
      return alert("이름을 입력해주세요.")
    }
    if (!reg.test(memberEmail) || memberEmail === '') {
      return alert("유효한 이메일을 입력해주세요.")
    }
    if (memberCellphone === '') {
      return alert("휴대폰 번호를 입력해주세요.")
    }
    return "success"
  }

  const saveDriver = async () => {
    setOnUpload(true)
    const validdate = isValiddate();
    if (validdate !== 'success') {
      setOnUpload(false)
      return;
    }
    const params = {
      'user_id': memberId || '',
      'password': memberPassword || '',
      'username': memberName || '',
      'email': memberEmail || '',
      'mobile_phone': Util.removeHyphens(memberCellphone) || '',
      'type': 'driver',
      'push_token': '',
      'status': 'Y',
      'company_id': companyId
    }
    const rs = await saveDriverAccount(params)
    if (rs.data.result === 'success') {
      setModalShow(false)
      setMemberId('')
      setMemberIdConfirm(false)
      setMemberPassword('')
      setMemberPasswordConfirm('')
      setMemberName('')
      setMemberEmail('')
      setMemberCellphone('')
      getDataList()
    }
    alert(rs.data?.msg)
    setOnUpload(false)
  }

  const uploadDriverExcel = async () => {
    setOnUpload(true)
    if (driverListFile == undefined || driverListFile?.length == 0) { setOnUpload(false); return alert('파일을 등록하세요.') }
    try {
      const params = {
        type: 'xlsx',
        category: 'driverListFile',
        company_id: companyId,
        member_id: myId
      }
      const fd = new FormData();
      fd.append('data', JSON.stringify(params));
      const newFile = new File([driverListFile[0]], `${encodeURI(driverListFile[0].name)}`, { type: driverListFile[0].type })
      if (driverListFile && !_.isEmpty(driverListFile)) {
        fd.append('file_0', newFile);
      }

      const response = await saveDriverExcel(fd)
      if (response.data?.result === 'success') {
        setIsRefresh(true)
        alert('정상적으로 등록되었습니다.')
      }

    } catch (e) {
      console.log(e)
    }
    setOnUpload(false)
    setDriverListFile([])
    setModalShow2(false)
    setOnUpload(false)
  }

  const deleteDriver = async (item) => {
    if (confirm("해당 운반기사를 삭제하시겠습니까?")) {
      setOnUpload(true)
      {
        const params = {
          user_id: item.member?.user_id + '_deleted_' + new Date().getTime(),
          email: item.member?.email + '_deleted',
          mobile_phone: item.member?.mobile_phone + '_deleted',
          status: 'N'
        }
        const response = await deleteDriverAccount(params, item.member?.id);
        if (response?.status === 200) {
          setIsRefresh(true)
          alert('정상적으로 삭제되었습니다.')
        }
      }
      setOnUpload(false)
    }
    getDataList()
  }

  const fileDownload = async (str) => {
    let url = `https://waveradmin.ropiklabs.com/media/sample/${str}.xlsx`
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const excelUrl = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = excelUrl;
        link.setAttribute('download', `${str}.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error)
      })
  };

  const updateDriver = async () => {
    const params = {
      user_id: memberId,
      username: memberName,
      email: memberEmail,
      mobile_phone: memberCellphone,
    }
    const response = await updateDriverList(params, selectedMemberId);
    if (response?.status === 200) {
      setModalShow3(false)
      setMemberId('')
      setMemberName('')
      setMemberEmail('')
      setMemberCellphone('')
      setSelectedMemberId('')
      getDataList()
      alert('정상적으로 수정되었습니다.')
    }else {
      alert('정보 수정에 실패하였습니다.')
    }
  }

  const openUpdateModal = (item) => {
    setModalShow3(true)
    setSelectedMemberId(item.member.id)
    setMemberId(item.member.user_id)
    setMemberName(item.member.username)
    setMemberEmail(item.member.email)
    setMemberCellphone(item.member.mobile_phone)
  }

  const registFiles = (e) => {
    setDriverListFile([...e.target.files])
  }

  const deleteFile = (item) => {
    setDriverListFile(driverListFile.filter(data => data !== item))
  }

  useEffect(() => {
    getDataList()
    if(!modalShow3){
      setMemberId('')
      setMemberName('')
      setMemberEmail('')
      setMemberCellphone('')
      setSelectedMemberId('')
    }
  }, [isRefresh, modalShow, modalShow2, modalShow3, page])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>운반기사 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="마이웨버" breadcrumbItem="운반기사 관리" />

          {!modalShow && !modalShow2 && !modalShow3 &&
            <Row>
              <Col xs={12} className="waver-pagination-btn-group mb-4 text-end" style={{maxWidth: '25.625rem'}}>
                {/* <button className="waves-effect submit-btn btn btn-secondary zfont-size-16"
                  onClick={() => { setModalShow2(true) }}>일괄등록</button> */}
                <button className="waves-effect submit-btn btn btn-secondary zfont-size-16 margin-left-16" onClick={() => { setModalShow(true) }}
                >개별등록</button>
              </Col>
            </Row>
          }

          <Row>
            <Col xs={12} style={{maxWidth: '25.625rem'}}>
              <div className="email-rightbar mb-3">
                <Card className="overflow-hidden">

                  {!modalShow && !modalShow2 && !modalShow3 &&
                    <div className="radius-4 overflow-hidden">
                      <div className="table-responsive">
                        <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                          <thead className="chart-thead">
                            <tr>
                              <th scope="col" >ID</th>
                              <th scope="col" >운반기사명</th>
                              <th scope="col" >휴대전화번호</th>
                              <th scope="col" >삭제</th>
                            </tr>
                          </thead>
                          <tbody className="chart-tbody">
                            {dataList && dataList.map((item, index) => {
                              return (
                                <tr className="pointer" key={item.id + '_' + index} onClick={() => { openUpdateModal(item) }}>
                                  <td>{item.member?.user_id}</td>
                                  <td>{item.member?.username}</td>
                                  <td>{Util.handleMobileNumberChange(item.member?.mobile_phone)}</td>
                                  <td><i className="mdi mdi-trash-can-outline font-size-18 pointer" onClick={() => {
                                    deleteDriver(item)
                                  }} /></td>
                                </tr>
                              )
                            })
                            }
                            {!dataList &&
                              <tr>
                                <td scope="row" colSpan="6">데이터가 없습니다.</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }

                  {modalShow &&
                    <CardBody className="p-4">

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">아이디</p>
                          <input type="text" placeholder="아이디를 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setMemberId(e.target.value)
                            setMemberIdConfirm(false)
                          }} />
                        </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16"
                            onClick={() => {
                              checkUserId()
                            }}
                          >중복확인</button>
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">비밀번호</p>
                          <input type="password" placeholder="비밀번호를 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setMemberPassword(e.target.value)
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">비밀번호 확인</p>
                          <input type="password" placeholder="비밀번호를 다시 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setMemberPasswordConfirm(e.target.value)
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">이름</p>
                          <input type="text" placeholder="실명을 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setMemberName(e.target.value)
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">이메일</p>
                          <input type="email" placeholder="사용중인 이메일을 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setMemberEmail(e.target.value)
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">휴대전화번호</p>
                          <input type="text" placeholder="휴대전화번호를 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" value={memberCellphone} onChange={(e) => {
                            setMemberCellphone(Util.handleMobileNumberChange(e.target.value))
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={() => {
                          saveDriver()
                        }}>등록하기</button>
                      </div>

                    </CardBody>
                  }

                  {modalShow2 &&
                    <CardBody className="p-4">

                      <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{ height: 'fit-content' }}>
                        <div className="d-flex align-items-top">
                          <Warning width={28} height={22} />
                          <p className="noMargin font-size-14 text-black padding-left-8">파일 업로드시, 기존 목록과 파일의 중복된 내용을 제외한 나머지 부분만 등록됩니다.  삭제는 개별 삭제 해주세요.</p>
                        </div>
                        <div className="waver-pagination-btn-group float-right d-flex justify-content-end">
                          <button className="waves-effect submit-btn btn btn-secondary font-size-14 mt-2"
                            onClick={() => {
                              fileDownload('운반기사등록엑셀')
                            }}
                          >샘플 엑셀파일 다운로드<Download className="margin-left-8" />
                          </button>
                        </div>
                      </div>

                      <label style={{ padding: '0.4rem 1rem', borderRadius: '0.2rem', margin: "18px 0", fontSize: 16 }} htmlFor="ex_file" className="btn btn-primary dropdown-toggle waves-effect waves-light">파일선택
                      </label>
                      <input style={{ display: "none" }} type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e) => {
                        registFiles(e)
                      }} />

                      {driverListFile.length > 0 && driverListFile.map((item, index) => {
                        return (
                          <div className="file-confirm" key={index}>
                            <p className="noMargin">{item.name}</p>
                            <Delete className="margin-left-8 pointer" onClick={() => { deleteFile(item) }} />
                          </div>
                        )
                      })}

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow2(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={async () => {
                          await uploadDriverExcel()
                        }}>등록하기</button>
                      </div>

                    </CardBody>
                  }

                  {modalShow3 &&
                    <CardBody className="p-4">

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">아이디</p>
                          <input type="text" placeholder="아이디를 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" defaultValue={memberId} onChange={(e) => {
                            setMemberId(e.target.value)
                            setMemberIdConfirm(false)
                          }} />
                        </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16"
                            onClick={() => {
                              checkUserId()
                            }}
                          >중복확인</button>
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">이름</p>
                          <input type="text" placeholder="실명을 입력해주세요" defaultValue={memberName} className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setMemberName(e.target.value)
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">이메일</p>
                          <input type="email" placeholder="사용중인 이메일을 입력해주세요" defaultValue={memberEmail} className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => {
                            setMemberEmail(e.target.value)
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mb-4">
                        <div style={{ flexGrow: 1 }}>
                          <p className="noMargin text-black font-weight-bold font-size-16">휴대전화번호</p>
                          <input type="text" placeholder="휴대전화번호를 입력해주세요" className="is-touched is-dirty av-valid form-control mt-2 font-size-16" value={Util.handleMobileNumberChange(memberCellphone)} onChange={(e) => {
                            setMemberCellphone(Util.handleMobileNumberChange(e.target.value))
                          }} />
                        </div>
                      </div>

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow3(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={() => {
                          updateDriver()
                        }}>수정하기</button>
                      </div>

                    </CardBody>
                  }

                  {onUpload && <div style={{
                    position: "absolute",
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    background: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 999,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img src={loading} alt="로딩중입니다." width={'5%'}></img>
                  </div>}

                </Card>

                {!modalShow && !modalShow2 && !modalShow3 &&
                  <Pagination contentCount={contentCount} pageArr={pageArr} pageCallBack={(page)=>{setPage(page)}} />
                }

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DriverManagementScreen